<template>
  <div class="dialog">
    <a-modal :centered="true" :title="title" width="50%" v-bind="$attrs" v-on="$listeners">
      <p class="home_dialog_text" v-for="(item,index) in data" :key="index">{{item}}</p>
    </a-modal>
  </div>
</template>

<script>
export default {
  props: {
    title: { type: String, default: null },
    data: { type: Array, default: () => [] }
  }
}
</script>

<style lang="less">
body {
  .ant-modal-root {
    .ant-modal-wrap {
      .ant-modal {
        .ant-modal-content {
          .ant-modal-body {
            .home_dialog_text {
              .pub_font_size(-1.5px);
              color: #8289a4;
            }
            .home_dialog_text:first-child {
              margin-bottom: 10px !important;
            }
          }
        }
      }
    }
  }
}
</style>